import { render, staticRenderFns } from "./zwyq.vue?vue&type=template&id=9686308c&scoped=true&"
import script from "./zwyq.vue?vue&type=script&lang=js&"
export * from "./zwyq.vue?vue&type=script&lang=js&"
import style0 from "./zwyq.vue?vue&type=style&index=0&id=9686308c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9686308c",
  null
  
)

export default component.exports